import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { ORMAS_STATISTICS } from "../utils";
import { loginUser } from "../actions/AuthAction";
import swal from "sweetalert";
import "../assets/scss/landing-page.scss";
import LogoRoteKu from "../assets/img/logorote.png";

// Use the imported logo file
const LogoRote = LogoRoteKu;

// Add custom styles for hover effects
const customStyles = `
  .feature-card-hover {
    transition: all 0.3s ease !important;
    cursor: pointer !important;
  }
  .feature-card-hover:hover {
    transform: translateY(-10px) !important;
    box-shadow: 0 20px 60px rgba(0,0,0,0.15) !important;
  }
`;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [statsData, setStatsData] = useState(null);
  const [loginProses, setLoginProses] = useState(false);
  const history = useHistory();

  useEffect(() => {
    // Fetch statistics data for landing page
    const fetchStats = async () => {
      setLoading(true);
      try {
        // Add timeout to prevent hanging
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

        const response = await fetch(`${ORMAS_STATISTICS}kecamatan-jenis`, {
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data.success) {
          setStatsData(data.data);
        } else {
          console.warn("API response indicates failure:", data.message);
          setStatsData([]);
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
        // Set default values if API fails
        setStatsData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []); // Remove DATA_DISABILITAS_GROUP from dependency array

  const totalOrmas = statsData
    ? statsData.reduce((sum, item) => sum + (item.total_ormas || 0), 0)
    : 0;
  const totalKecamatan = statsData ? statsData.length : 0;

  // Fallback values if data is not available
  const displayTotalOrmas = loading ? 0 : totalOrmas;
  const displayTotalKecamatan = loading ? 0 : totalKecamatan;

  // Scroll to section function
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Handle login dengan versi original
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginProses(true);
    setError("");

    if (email && password) {
      // Gunakan action login original
      loginUser(email, password, setLoginProses, history);
    } else {
      swal("Failed", "Maaf Email dan Password Harus Diisi", "error");
      setLoginProses(false);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    // Reset form when opening modal
    if (!isModalOpen) {
      setEmail("");
      setPassword("");
      setError("");
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="landing-page">
      <style>{customStyles}</style>
      {/* Navigation */}
      <nav
        className="landing-nav"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "15px 0",
          boxShadow: "0 2px 20px rgba(0,0,0,0.1)",
        }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md="6">
              <div
                className="nav-brand"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    borderRadius: "50%",
                    padding: "8px",
                    marginRight: "15px",
                  }}
                >
                  <img
                    src={LogoRote}
                    alt="Logo SIO ESA"
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "white",
                    fontSize: "24px",
                    fontWeight: "bold",
                    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                  }}
                >
                  SIO ESA
                </span>
              </div>
            </Col>
            <Col md="6">
              <div
                className="nav-menu"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <Button
                  color="outline-light"
                  size="sm"
                  onClick={() => scrollToSection("features")}
                  style={{
                    borderRadius: "25px",
                    border: "2px solid rgba(255,255,255,0.8)",
                    fontWeight: "600",
                  }}
                >
                  <i className="tim-icons icon-settings mr-2"></i>
                  Layanan
                </Button>
                <Button
                  color="outline-light"
                  size="sm"
                  onClick={() => scrollToSection("info")}
                  style={{
                    borderRadius: "25px",
                    border: "2px solid rgba(255,255,255,0.8)",
                    fontWeight: "600",
                  }}
                >
                  <i className="tim-icons icon-chart-pie-36 mr-2"></i>
                  Informasi
                </Button>
                <Button
                  color="light"
                  size="sm"
                  onClick={toggleModal}
                  style={{
                    borderRadius: "25px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  }}
                >
                  <i className="tim-icons icon-single-02 mr-2"></i>
                  Login
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </nav>

      {/* Header */}
      <div
        className="landing-header"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "80px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            background:
              'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')',
            opacity: "0.3",
          }}
        ></div>
        <Container>
          <Row className="align-items-center">
            <Col md="6">
              <div
                className="hero-content"
                style={{ position: "relative", zIndex: "2" }}
              >
                <div className="hero-logo mb-4" style={{ textAlign: "center" }}>
                  <div
                    style={{
                      display: "inline-block",
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "50%",
                      padding: "20px",
                      backdropFilter: "blur(10px)",
                      border: "2px solid rgba(255,255,255,0.3)",
                    }}
                  >
                    <img
                      src={LogoRote}
                      alt="Logo SIO ESA"
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <h1
                  className="hero-title"
                  style={{
                    color: "white",
                    fontSize: "3.5rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: "20px",
                    textShadow: "0 4px 8px rgba(0,0,0,0.3)",
                  }}
                >
                  SIO ESA
                </h1>
                <h2
                  className="hero-subtitle"
                  style={{
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "1.5rem",
                    textAlign: "center",
                    marginBottom: "25px",
                    fontWeight: "300",
                  }}
                >
                  Sistem Informasi Pelaporan Organisasi Kemasyarakatan
                </h2>
                <p
                  className="hero-description"
                  style={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "1.1rem",
                    textAlign: "center",
                    marginBottom: "40px",
                    lineHeight: "1.6",
                  }}
                >
                  Platform terpadu untuk pelaporan keberadaan dan kegiatan
                  Organisasi Kemasyarakatan (ORMAS) di Kabupaten Rote Ndao
                </p>
                <div className="hero-buttons" style={{ textAlign: "center" }}>
                  <Button
                    color="light"
                    size="lg"
                    onClick={toggleModal}
                    style={{
                      borderRadius: "30px",
                      padding: "12px 30px",
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      marginRight: "15px",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
                      border: "none",
                    }}
                  >
                    <i className="tim-icons icon-single-02 mr-2"></i>
                    Login Admin
                  </Button>
                  <Button
                    color="outline-light"
                    size="lg"
                    onClick={() => scrollToSection("features")}
                    style={{
                      borderRadius: "30px",
                      padding: "12px 30px",
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      border: "2px solid rgba(255,255,255,0.8)",
                      background: "transparent",
                    }}
                  >
                    <i className="tim-icons icon-settings mr-2"></i>
                    Pelajari Lebih Lanjut
                  </Button>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div
                className="hero-image"
                style={{ position: "relative", zIndex: "2" }}
              >
                <div className="stats-cards" style={{ padding: "20px" }}>
                  <Row>
                    <Col sm="6">
                      <Card
                        className="stat-card"
                        style={{
                          background: "rgba(255,255,255,0.95)",
                          borderRadius: "20px",
                          border: "none",
                          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                          backdropFilter: "blur(10px)",
                          marginBottom: "20px",
                        }}
                      >
                        <CardBody
                          className="text-center"
                          style={{ padding: "30px 20px" }}
                        >
                          <div
                            style={{
                              background:
                                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              borderRadius: "50%",
                              width: "60px",
                              height: "60px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 15px",
                            }}
                          >
                            <i
                              className="tim-icons icon-chart-bar-32"
                              style={{
                                fontSize: "1.5rem",
                                color: "white",
                              }}
                            ></i>
                          </div>
                          <h3
                            className="stat-number"
                            style={{
                              fontSize: "2.5rem",
                              fontWeight: "bold",
                              color: "#333",
                              marginBottom: "10px",
                            }}
                          >
                            {loading ? (
                              <i className="tim-icons icon-refresh-02 fa-spin"></i>
                            ) : (
                              displayTotalOrmas
                            )}
                          </h3>
                          <p
                            className="stat-label"
                            style={{
                              color: "#666",
                              fontSize: "1rem",
                              fontWeight: "600",
                              margin: "0",
                            }}
                          >
                            Total ORMAS
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="6">
                      <Card
                        className="stat-card"
                        style={{
                          background: "rgba(255,255,255,0.95)",
                          borderRadius: "20px",
                          border: "none",
                          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                          backdropFilter: "blur(10px)",
                          marginBottom: "20px",
                        }}
                      >
                        <CardBody
                          className="text-center"
                          style={{ padding: "30px 20px" }}
                        >
                          <div
                            style={{
                              background:
                                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              borderRadius: "50%",
                              width: "60px",
                              height: "60px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 15px",
                            }}
                          >
                            <i
                              className="tim-icons icon-map-big"
                              style={{
                                fontSize: "1.5rem",
                                color: "white",
                              }}
                            ></i>
                          </div>
                          <h3
                            className="stat-number"
                            style={{
                              fontSize: "2.5rem",
                              fontWeight: "bold",
                              color: "#333",
                              marginBottom: "10px",
                            }}
                          >
                            {loading ? (
                              <i className="tim-icons icon-refresh-02 fa-spin"></i>
                            ) : (
                              displayTotalKecamatan
                            )}
                          </h3>
                          <p
                            className="stat-label"
                            style={{
                              color: "#666",
                              fontSize: "1rem",
                              fontWeight: "600",
                              margin: "0",
                            }}
                          >
                            Kecamatan
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Features Section */}
      <div
        className="features-section"
        id="features"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          padding: "80px 0",
          position: "relative",
        }}
      >
        <Container>
          <Row>
            <Col md="12">
              <h2
                className="section-title text-center mb-5"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "60px",
                }}
              >
                <i
                  className="tim-icons icon-settings text-primary mr-3"
                  style={{ fontSize: "2rem" }}
                ></i>
                Layanan yang Tersedia
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <Card
                className="feature-card feature-card-hover"
                style={{
                  borderRadius: "20px",
                  border: "none",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                  marginBottom: "30px",
                  overflow: "hidden",
                }}
              >
                <CardBody
                  className="text-center"
                  style={{ padding: "40px 30px" }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      borderRadius: "50%",
                      width: "80px",
                      height: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 25px",
                    }}
                  >
                    <i
                      className="tim-icons icon-single-02"
                      style={{
                        fontSize: "2rem",
                        color: "white",
                      }}
                    ></i>
                  </div>
                  <h4
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "20px",
                    }}
                  >
                    Pelaporan Keberadaan ORMAS
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      lineHeight: "1.6",
                      marginBottom: "25px",
                    }}
                  >
                    Pendataan lengkap organisasi kemasyarakatan meliputi nama
                    organisasi, alamat sekretariat, data pengurus, klasifikasi
                    organisasi, dan dokumen pendukung pelaporan.
                  </p>
                  <div className="feature-badge">
                    <span
                      className="badge"
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: "white",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                      }}
                    >
                      Wajib Diisi
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card
                className="feature-card feature-card-hover"
                style={{
                  borderRadius: "20px",
                  border: "none",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                  marginBottom: "30px",
                  overflow: "hidden",
                }}
              >
                <CardBody
                  className="text-center"
                  style={{ padding: "40px 30px" }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      borderRadius: "50%",
                      width: "80px",
                      height: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 25px",
                    }}
                  >
                    <i
                      className="tim-icons icon-chart-pie-36"
                      style={{
                        fontSize: "2rem",
                        color: "white",
                      }}
                    ></i>
                  </div>
                  <h4
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "20px",
                    }}
                  >
                    Pelaporan Kegiatan ORMAS
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      lineHeight: "1.6",
                      marginBottom: "25px",
                    }}
                  >
                    Pendataan kegiatan yang dilaksanakan ORMAS termasuk bidang
                    kegiatan, sumber anggaran, periode pelaksanaan, lokasi,
                    jumlah peserta, dan dokumentasi kegiatan.
                  </p>
                  <div className="feature-badge">
                    <span
                      className="badge"
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: "white",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                      }}
                    >
                      Khusus
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card
                className="feature-card feature-card-hover"
                style={{
                  borderRadius: "20px",
                  border: "none",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                  marginBottom: "30px",
                  overflow: "hidden",
                }}
              >
                <CardBody
                  className="text-center"
                  style={{ padding: "40px 30px" }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      borderRadius: "50%",
                      width: "80px",
                      height: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 25px",
                    }}
                  >
                    <i
                      className="tim-icons icon-paper"
                      style={{
                        fontSize: "2rem",
                        color: "white",
                      }}
                    ></i>
                  </div>
                  <h4
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "20px",
                    }}
                  >
                    Manajemen Data ORMAS
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      lineHeight: "1.6",
                      marginBottom: "25px",
                    }}
                  >
                    Pengelolaan data organisasi kemasyarakatan yang terdaftar,
                    monitoring status pelaporan, dan pencarian data ORMAS
                    berdasarkan berbagai kriteria.
                  </p>
                  <div className="feature-badge">
                    <span
                      className="badge"
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: "white",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                      }}
                    >
                      Layanan
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        <Container>
          <Row>
            <Col md="12">
              <h2 className="section-title text-center mb-5 text-white">
                <i className="tim-icons icon-chart-bar-32 mr-2"></i>
                Statistik ORMAS
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-single-02 text-primary"></i>
                <h3>
                  {loading ? (
                    <i className="tim-icons icon-refresh-02 fa-spin"></i>
                  ) : (
                    displayTotalOrmas
                  )}
                </h3>
                <p>Total Disabilitas</p>
              </div>
            </Col>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-map-big text-info"></i>
                <h3>
                  {loading ? (
                    <i className="tim-icons icon-refresh-02 fa-spin"></i>
                  ) : (
                    displayTotalKecamatan
                  )}
                </h3>
                <p>Kecamatan</p>
              </div>
            </Col>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-bank text-success"></i>
                <h3>1</h3>
                <p>Kabupaten</p>
              </div>
            </Col>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-paper text-warning"></i>
                <h3>6</h3>
                <p>Jenis Layanan</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Information Section */}
      <div className="info-section" id="info">
        <Container>
          <Row>
            <Col md="12">
              <h2 className="section-title text-center mb-5">
                <i className="tim-icons icon-bulb-63 text-warning mr-2"></i>
                Informasi Layanan
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={activeTab === "1" ? "active" : ""}
                        onClick={() => toggleTab("1")}
                      >
                        <i className="tim-icons icon-single-02 mr-2"></i>
                        Data Individu
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "2" ? "active" : ""}
                        onClick={() => toggleTab("2")}
                      >
                        <i className="tim-icons icon-chart-pie-36 mr-2"></i>
                        Pelaporan ORMAS
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <h5>Pelaporan Keberadaan ORMAS</h5>
                      <p>
                        Formulir wajib diisi dengan kolom-kolom sebagai berikut:
                      </p>
                      <ul>
                        <li>
                          <strong>Nama Organisasi</strong>
                        </li>
                        <li>
                          <strong>Email Organisasi</strong>
                        </li>
                        <li>
                          <strong>Alamat Sekretariat</strong>
                        </li>
                        <li>
                          <strong>Data Pengurus</strong> (Ketua, Sekretaris,
                          Bendahara)
                        </li>
                        <li>
                          <strong>Klasifikasi Organisasi</strong> (Berbadan
                          Hukum/Tidak Berbadan Hukum)
                        </li>
                        <li>
                          <strong>Jenis Organisasi</strong> (Yayasan,
                          Perkumpulan, Forum, Lembaga, Lainnya)
                        </li>
                        <li>
                          <strong>Dokumen Pendukung</strong> (AKTA, SKT/AHU,
                          Surat Domisili, dll.)
                        </li>
                      </ul>
                    </TabPane>
                    <TabPane tabId="2">
                      <h5>Pelaporan Kegiatan ORMAS</h5>
                      <Row>
                        <Col md="6">
                          <h6>A. Informasi Kegiatan:</h6>
                          <ul>
                            <li>☐ Nama Organisasi</li>
                            <li>☐ Bidang Kegiatan</li>
                            <li>☐ Sumber Anggaran</li>
                            <li>☐ Periode Pelaksanaan</li>
                            <li>☐ Lokasi Kegiatan</li>
                          </ul>
                        </Col>
                        <Col md="6">
                          <h6>B. Dokumentasi Kegiatan:</h6>
                          <ul>
                            <li>☐ STTPKO</li>
                            <li>☐ Laporan Kegiatan</li>
                            <li>☐ Dokumentasi Foto/Video</li>
                            <li>☐ Jumlah Peserta</li>
                            <li>☐ Anggaran Kegiatan</li>
                          </ul>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Footer */}
      <div
        className="landing-footer"
        style={{
          background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
          padding: "60px 0 40px",
          color: "white",
        }}
      >
        <Container>
          <Row>
            <Col md="12" className="text-center">
              <div className="footer-logo mb-4">
                <div
                  style={{
                    display: "inline-block",
                    background: "rgba(255,255,255,0.1)",
                    borderRadius: "50%",
                    padding: "15px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={LogoRote}
                    alt="Logo SIO ESA"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
              <h4
                style={{
                  color: "white",
                  fontSize: "1.8rem",
                  fontWeight: "bold",
                  marginBottom: "15px",
                }}
              >
                Badan Kesbangpol Kabupaten Rote Ndao
              </h4>
              <p
                style={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: "1.1rem",
                  marginBottom: "30px",
                  lineHeight: "1.6",
                }}
              >
                Memfasilitasi pelaporan ORMAS sesuai ketentuan
                perundang-undangan
              </p>
              <div
                style={{
                  borderTop: "1px solid rgba(255,255,255,0.2)",
                  paddingTop: "30px",
                  marginTop: "30px",
                }}
              >
                <p
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: "0.9rem",
                    margin: "0",
                  }}
                >
                  © 2024 SIO ESA. Semua hak dilindungi.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Login Modal */}
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="md"
        style={{
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        <ModalHeader
          toggle={toggleModal}
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            borderBottom: "none",
            padding: "25px 30px",
          }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                background: "rgba(255,255,255,0.2)",
                borderRadius: "50%",
                padding: "8px",
                marginRight: "15px",
              }}
            >
              <img
                src={LogoRote}
                alt="Logo SIO ESA"
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </div>
            <span
              style={{
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              Login Admin SIO ESA
            </span>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "30px" }}>
          <Form onSubmit={handleLogin}>
            <FormGroup style={{ marginBottom: "25px" }}>
              <Label
                for="email"
                style={{
                  fontWeight: "600",
                  color: "#333",
                  marginBottom: "8px",
                }}
              >
                Email Address
              </Label>
              <Input
                type="text"
                name="text"
                value={email}
                placeholder="Masukkan email Anda"
                onChange={(event) => setEmail(event.target.value)}
                style={{
                  borderRadius: "10px",
                  border: "2px solid #e9ecef",
                  padding: "12px 15px",
                  fontSize: "1rem",
                }}
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: "25px" }}>
              <Label
                for="password"
                style={{
                  fontWeight: "600",
                  color: "#333",
                  marginBottom: "8px",
                }}
              >
                Password
              </Label>
              <Input
                type="password"
                name="password"
                value={password}
                placeholder="Masukkan password Anda"
                onChange={(event) => setPassword(event.target.value)}
                style={{
                  borderRadius: "10px",
                  border: "2px solid #e9ecef",
                  padding: "12px 15px",
                  fontSize: "1rem",
                }}
              />
            </FormGroup>
            {error && (
              <Alert
                color="danger"
                style={{
                  borderRadius: "10px",
                  marginBottom: "20px",
                }}
              >
                {error}
              </Alert>
            )}
          </Form>
        </ModalBody>
        <ModalFooter
          style={{
            borderTop: "1px solid #e9ecef",
            padding: "20px 30px",
            background: "#f8f9fa",
          }}
        >
          <Button
            color="secondary"
            onClick={toggleModal}
            style={{
              borderRadius: "25px",
              padding: "10px 20px",
              fontWeight: "600",
            }}
          >
            Batal
          </Button>
          {loginProses ? (
            <Button
              color="primary"
              disabled
              style={{
                borderRadius: "25px",
                padding: "10px 25px",
                fontWeight: "600",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
              }}
            >
              <i className="tim-icons icon-refresh-02 fa-spin mr-2"></i>
              Loading
            </Button>
          ) : (
            <Button
              color="primary"
              onClick={handleLogin}
              style={{
                borderRadius: "25px",
                padding: "10px 25px",
                fontWeight: "600",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
              }}
            >
              <i className="tim-icons icon-single-02 mr-2"></i>
              Login
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Login;
